export const products = [
  {
    id: 1,
    name: "Aura King",
    type: "king",
    badge: "Para Él",
    tagline: "Despierta tu poder interior",
    description:
      "Fórmula suprema diseñada para el hombre moderno. Potencia tu energía, deseo y resistencia con ingredientes naturales de la más alta calidad.",
    contents: "12 sachets · 20g c/u · Cnt Net: 240g",
    price: "$450 MXN",
    benefits: [
      "Aumenta energía y vitalidad",
      "Estimula el deseo natural",
      "Mejora la resistencia física",
      "Ingredientes Naturales de Alta Calidad",
      "Fórmula afrodisíaca premium",
    ],
    ingredients: [
      "Pasta de cacao premium",
      "Aceite de coco extra virgen",
      "L-citrulina de alta pureza",
      "Epimedium grandiflorum",
      "Panax ginseng",
      "Eurycoma longifolia",
    ],
    rating: 4.9,
    reviews: 128,
  },
  {
    id: 2,
    name: "Aura Queen",
    type: "queen",
    badge: "Para Ella",
    tagline: "Revela tu esencia suprema",
    description:
      "Fórmula exclusiva creada para la mujer contemporánea. Despierta tu sensualidad, energía y conexión con ingredientes de origen natural.",
    contents: "12 sachets · 20g c/u · Cnt Net: 240g",
    price: "$450 MXN",
    benefits: [
      "Eleva energía femenina",
      "Potencia el deseo y la pasión",
      "Aumenta resistencia y bienestar",
      "Ingredientes Naturales de Alta Calidad",
      "Fórmula afrodisíaca premium",
    ],
    ingredients: [
      "Pasta de cacao premium",
      "Aceite de coco extra virgen",
      "L-teanina de alta pureza",
      "Epimedium grandiflorum",
      "Turnera diffusa",
      "Ginkgo biloba",
    ],
    rating: 4.9,
    reviews: 115,
  },
];

export const features = [
  {
    id: 1,
    icon: "Zap",
    title: "Energía Suprema",
    description:
      "Experimenta un aumento natural de energía que te mantiene activo y vigoroso durante todo el día. Sin estimulantes artificiales, solo potencia natural.",
    detail:
      "Ingredientes como L-citrulina y Panax ginseng activan la producción de energía celular de forma sostenida y duradera.",
  },
  {
    id: 2,
    icon: "Flame",
    title: "Deseo Intensificado",
    description:
      "Ingredientes afrodisíacos con respaldo científico que despiertan y potencian el deseo de forma natural y segura.",
    detail:
      "El Epimedium grandiflorum ha sido utilizado por siglos como potenciador del deseo en la medicina tradicional asiática.",
  },
  {
    id: 3,
    icon: "Shield",
    title: "Resistencia Mejorada",
    description:
      "Aumenta tu resistencia física y mental. Cada sachet está formulado para maximizar tu rendimiento y vitalidad.",
    detail:
      "La Eurycoma longifolia y adaptógenos naturales apoyan la resistencia muscular y la recuperación activa.",
  },
  {
    id: 4,
    icon: "Leaf",
    title: "Natural",
    description:
      "Elaborado con ingredientes de origen natural, sin aditivos artificiales. Certificado y seguro para su consumo.",
    detail:
      "Todos nuestros ingredientes son trazables y de origen orgánico, sin conservadores ni colorantes artificiales.",
  },
  {
    id: 5,
    icon: "Heart",
    title: "Conexión Profunda",
    description:
      "Fortalece la conexión íntima entre parejas. Una experiencia que va más allá de lo físico, elevando el bienestar compartido.",
    detail:
      "La combinación King & Queen crea una sinergia única, potenciando la conexión emocional y física en pareja.",
  },
  {
    id: 6,
    icon: "Crown",
    title: "Calidad Supreme",
    description:
      "Cada lote es verificado bajo estrictos estándares de calidad. El chocolate afrodisíaco más sofisticado de México.",
    detail:
      "Elaborado con cacao de primera selección y empacado bajo condiciones óptimas de conservación y frescura.",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos M.",
    location: "Ciudad de México",
    rating: 5,
    text: "Increíble producto. Desde el primer sachet noté la diferencia en mi energía y vitalidad. Totalmente recomendado para cualquier hombre que quiera vivir al máximo.",
    product: "Aura King",
    avatar: "CM",
  },
  {
    id: 2,
    name: "Sofía R.",
    location: "Guadalajara",
    rating: 5,
    text: "Aura Queen cambió mi vida. Me siento más energizada, conectada y apasionada. El sabor del chocolate es delicioso y los resultados son muy reales.",
    product: "Aura Queen",
    avatar: "SR",
  },
  {
    id: 3,
    name: "Roberto P.",
    location: "Monterrey",
    rating: 5,
    text: "Lo compramos mi esposa y yo juntos. Los dos tomamos y fue una experiencia increíble. La calidad es premium, se nota desde el empaque elegante.",
    product: "Aura King & Queen",
    avatar: "RP",
  },
  {
    id: 4,
    name: "Valeria G.",
    location: "Puebla",
    rating: 5,
    text: "Pensé que era un producto más, pero me equivoqué completamente. La fórmula realmente funciona. Mi energía aumentó notablemente y me siento increíble.",
    product: "Aura Queen",
    avatar: "VG",
  },
];

export const faqs = [
  {
    id: "faq-1",
    question: "¿Cómo se consume Aura Chocolate Supreme?",
    answer:
      "Cada sachet contiene 20g de chocolate afrodisíaco. Se puede consumir directamente o disuelto en leche caliente o fría. Se recomienda 1 sachet por día, preferiblemente 15 minutos antes de la actividad deseada.",
  },
  {
    id: "faq-2",
    question: "¿Es seguro para consumo?",
    answer:
      "Sí, Aura Chocolate Supreme está elaborado con ingredientes naturales de alta calidad y es completamente seguro para adultos mayores de 18 años. No contiene sustancias prohibidas ni estimulantes artificiales dañinos.",
  },
  {
    id: "faq-3",
    question: "¿Cuánto tiempo tarda en hacer efecto?",
    answer:
      "Los efectos generalmente se sienten a los 15 minutos. Los resultados son graduales y consistentes con el uso regular del producto.",
  },
  {
    id: "faq-4",
    question: "¿Puedo tomar King y Queen juntos como pareja?",
    answer:
      "¡Absolutamente! De hecho, es la forma ideal de usar Aura. King y Queen están formulados para complementarse, creando una experiencia única cuando ambos miembros de la pareja los consumen al mismo tiempo.",
  },
  {
    id: "faq-5",
    question: "¿Hacen envíos a toda la República Mexicana?",
    answer:
      "Por el momento no contamos con envíos a toda la República Mexicana, pero estamos trabajando para hacerlo posible lo más pronto posible.",
  },
  {
    id: "faq-6",
    question: "¿Cuáles son los ingredientes principales?",
    answer:
      "Los ingredientes base incluyen pasta de cacao premium y aceite de Cocos nucifera. La fórmula King incluye L-citrulina, Panax ginseng y Eurycoma longifolia. La fórmula Queen incluye L-teanina, Turnera diffusa y Ginkgo biloba.",
  },
];

export const usageSteps = [
  {
    step: "01",
    title: "Abre el Sachet",
    desc: "Retira el sello del sachet de 20g de Aura Chocolate Supreme con cuidado.",
  },
  {
    step: "02",
    title: "Prepara tu Bebida",
    desc: "Disuélvelo en tu bebida favorita o tómalo directamente para mayor concentración.",
  },
  {
    step: "03",
    title: "Espera 15 Minutos",
    desc: "Consume 15 minutos antes para experimentar los beneficios en su máximo potencial.",
  },
  {
    step: "04",
    title: "Disfruta",
    desc: "Vive la experiencia Aura Supreme al máximo. Energía, deseo y conexión profunda.",
  },
];
